import React, {useState,useEffect, forwardRef} from 'react';
import axios from 'axios';
import { CSVLink } from "react-csv";
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { apiURL } from '../Constant';
import './FeedbackData.css';

function FeedbackData() {                  
    const [feedbacks, setFeedbacks] = useState([]);
    const [feedbacksDataForDownload, setFeedbacksDataForDownload] = useState([]);    
    
    const [fromStartDate, setFromStartDate] = useState(new Date("2022/12/01"));    
    const [toEndDate, setToEndDate] = useState(new Date());    

    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <button className="date-picker-input-btn" onClick={onClick} ref={ref}>
          {value}
        </button>
    ));

    const handleStartDate = (date) => {        
        setFromStartDate(date)   
        let startDate = Moment(date).format('YYYY-MM-DD');
        let endDate = Moment(toEndDate).endOf('month').format('YYYY-MM-DD');                         
        fetchFilteredAPI(startDate, endDate);        
    }

    const handleEndDate = (date) => {                
        setToEndDate(date)        
        let startDate = Moment(fromStartDate).format('YYYY-MM-DD');
        let endDate = Moment(date).endOf('month').format('YYYY-MM-DD');                
        fetchFilteredAPI(startDate, endDate);        
    }

    const handleFeedbackDownload = () => {
        let updatedDownloadData = feedbacksDataForDownload.map((feedback, idx) => {            
            return {                
                'SL#': idx + 1,
                'Enterprise Id': feedback.enterprise_id,
                'Rating': feedback.rating === 0 ? '' : feedback.rating,
                'Comment': feedback.comment.trim(),
                'Submitted Date': `${Moment(feedback.created_at).format('DD-MM-YYYY')}`,                                
            };
        })        
        setFeedbacksDataForDownload(updatedDownloadData);
    }

    const fetchData = async () => {
        try {
                let response = await axios({
                    method: 'get',
                    url: `${apiURL}/feedback`,
                    headers: {              
                        'Authorization': sessionStorage.getItem("token"),
                        'Content-Type': 'application/json'
                      }                                                          
                })                                     
                setFeedbacks(response.data.results);
                setFeedbacksDataForDownload(response.data.results);
        } catch(error) {
            // console.log(error);
        }        
    }

    const fetchFilteredAPI = async (startDate, endDate) => {
        try {
                let response = await axios({
                    method: 'get',
                    url: `https://atci.lkm.accenture.com/lkm-apis/feedback/${startDate}/${endDate}`,
                    headers: {              
                        'Authorization': sessionStorage.getItem("token"),
                        'Content-Type': 'application/json'
                      }                                                 
                })                                     
                setFeedbacks(response.data.results);
                setFeedbacksDataForDownload(response.data.results);
        } catch(error) {
            // console.log(error);
        }        
    }
    
    useEffect(() => {
        
        fetchData();
    },[]);

    return (
        <div className='feedback-admin'>
            <h2>Shell University Feedbacks</h2>                        
            <div className='main-content'>
                <div className='header-container'>                                                     
                        <div className='date-picker-container'>
                            <span className='filter-text'>Filter | &nbsp;</span>
                            <div className='date-picker-start'>                    
                                <DatePicker
                                    selected={fromStartDate}
                                    onChange={(date) => handleStartDate(date)}                                    
                                    minDate={new Date("2022/12/01")}
                                    maxDate={toEndDate}
                                    showMonthYearPicker
                                    dateFormat="MM, yyyy"
                                    customInput={<DatePickerInput/>}
                                />
                            </div>
                            <span className='filter-text'> &nbsp;&nbsp;to&nbsp;&nbsp; </span> 
                            <div className='date-picker-end'> 
                                <DatePicker
                                    selected={toEndDate}
                                    onChange={(date) => handleEndDate(date)}                                    
                                    minDate={fromStartDate}
                                    maxDate={new Date()}  
                                    showMonthYearPicker
                                    dateFormat="MM, yyyy"
                                    customInput={<DatePickerInput/>}
                                />
                            </div>    
                        </div>                                                            
                        {feedbacksDataForDownload.length > 0 && <div className='lkm-feedback-download'>Feedback |&nbsp;
                            <CSVLink filename={`SU-feedback.csv`} data={feedbacksDataForDownload} onClick={handleFeedbackDownload}>Download</CSVLink>
                        </div>}                                                                                             
                </div>                         
                <table>                
                    <thead>
                        <tr>
                            <th>SL#</th>
                            <th>Enterprise Id</th>
                            <th>Rating</th>
                            <th>Comment</th>
                            <th>feedback submitted date</th>                        
                        </tr>                                                
                    </thead>    
                    <tbody>                
                    {feedbacks.length > 0 ? feedbacks.map((feedback, idx) => {                                                                      
                        return <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{feedback.enterprise_id}</td>
                            <td>{feedback.rating !== 0 ? feedback.rating : '-'}</td>
                            <td>{feedback.comment !== '' ? feedback.comment : '-'}</td>
                            <td>{Moment(feedback.created_at).format('DD-MM-YYYY')}</td>                       
                        </tr>
                    }) : <tr><td colspan="5">No Feedbacks Found </td></tr>}                            
                    </tbody>
                </table>
            </div>                        
        </div>        
    )
}

export default FeedbackData;